import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ConfigProvider } from "../../../config-provider.service";
import { CurrentUser } from "../../../common/providers/current-user";
import { EvaluationAthleteProvider } from '../../../evaluation-athlete/providers/evaluation-athlete-provider.services';
import { catchError, finalize, map, tap } from 'rxjs/operators';
import { Observable, Subscription, throwError } from 'rxjs';
import { Athlete } from "../../../common/models/athlete";
import { Organization } from "../../../common/models/organization";
import { MatChip, MatChipSet, MatChipsModule } from "@angular/material/chips";
import { MatList, MatListItem, MatListModule } from "@angular/material/list";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { DatePipe, NgClass, NgForOf, NgIf } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { RouterLink } from "@angular/router";
import { MatMiniFabButton } from "@angular/material/button";
import { MatLine } from "@angular/material/core";
import { MatTooltip } from "@angular/material/tooltip";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { User } from "../../../common/models/user";

@Component({
  selector: 'athlete-evaluation-box',
  providers: [],
  styleUrls: ['./evaluation-box.scss'],
  standalone: true,
  imports: [
    MatListModule,
    MatProgressSpinner,
    DatePipe,
    TranslateModule,
    NgIf,
    NgForOf,
    RouterLink,
    MatMiniFabButton,
    MatLine,
    MatTooltip,
    MatIconModule,
    MatChipsModule,
    NgClass,
  ],
  templateUrl: './evaluation-box.html'
})
export class EvaluationBoxComponent implements OnInit, OnDestroy {
    public isLoading = true;
    public is401 = false;
    public is404 = false;

    public evaluationAthleteData: any[] = [];

    @Input()
    public organization: Organization = {} as Organization;

    @Input()
    public athleteUser: User = {} as User;

    public subscriptions: Subscription[] = [];

    constructor(
        private evaluationAthleteProvider: EvaluationAthleteProvider,
        public conf: ConfigProvider,
        public currentUser: CurrentUser,
    ) {
    }

    public ngOnInit() {
      this.subscriptions.push(this.loadData().subscribe());
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public loadData() : Observable<void> {
      if (!this.organization || !this.athleteUser) {
        const error = new Error('Organization or athlete is not properly defined');
        this.onError(error);
        return throwError(() => error);
      }

      return this.evaluationAthleteProvider.getPreview(this.organization, this.athleteUser.athlete!).pipe(
        map((evaluations) => {
          this.evaluationAthleteData = evaluations;
        }),
        finalize(() => {
          this.isLoading = false;
        }),
        catchError(error => {
          this.onError(error);
          return throwError(() => error);
        })
      );
    }

    private onError(error: any): void {
        this.isLoading = false;

        if (error.status === 404) {
            this.is404 = true;
        } else if (error.status === 401) {
            this.is401 = true;
        }
    }
}
